/**
 * @generated SignedSource<<9b5ea6d102c9bf97d4070bf649f690eb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type TeamInputQuery$variables = {
  node?: string | null;
};
export type TeamInputQuery$data = {
  readonly viewer: {
    readonly teams: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly archived: boolean;
          readonly id: string;
          readonly title: string;
        };
      }>;
    } | null;
  };
};
export type TeamInputQuery = {
  response: TeamInputQuery$data;
  variables: TeamInputQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "node"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": [
    {
      "kind": "Variable",
      "name": "forNode",
      "variableName": "node"
    }
  ],
  "concreteType": "TeamConnection",
  "kind": "LinkedField",
  "name": "teams",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "TeamEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Team",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v1/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "title",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "archived",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "TeamInputQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "TeamInputQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v1/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "e3eeb30eb9a411fc74e9e99084b0b38f",
    "id": null,
    "metadata": {},
    "name": "TeamInputQuery",
    "operationKind": "query",
    "text": "query TeamInputQuery(\n  $node: String\n) {\n  viewer {\n    teams(forNode: $node) {\n      edges {\n        node {\n          id\n          title\n          archived\n        }\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "96787692eb67667ec939b068230df6f9";

export default node;
